// extracted by mini-css-extract-plugin
export default {"form":"AlbumsList_form__grbV0","input":"AlbumsList_input__AZGpz","submitBtn":"AlbumsList_submitBtn__s9LxB"};